<template>
  <span class="flex items-center gap-1 text-xs text-gray-400 antialiased">
    <slot />
  </span>
</template>
